import React, { useContext, useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { useQuery } from "react-query";

import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";

import PageHeader from "../../components/PageHeader";
import SectionCard from "../../components/SectionCard";
import DataTable from "../../components/DataTable";
import StatusBadge from "../../components/StatusBadge";
import { getLogs } from "../../api/logsApi";
import { LanguageContext } from "../../components/LanguageContext";

const LogsPage = () => {
    const { translations } = useContext(LanguageContext) || {};
    const { data, isLoading } = useQuery({
        queryKey: ["logs"],
        queryFn: () => getLogs(),
    });

    const columns = useMemo(
        () => [
            {
                field: "id",
                headerName: "ID",
                width: 70,
                align: "center",
                headerAlign: "center",
                renderCell: (p) => (
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ fontFamily: "monospace" }}
                    >
                        {p.value}
                    </Typography>
                ),
            },
            {
                field: "type",
                headerName:
                    translations?.adminLogsPageNotificationType || "Tip",
                minWidth: 160,
                renderCell: (p) => (
                    <StatusBadge
                        status="neutral"
                        showDot={false}
                        label={p.value || "—"}
                    />
                ),
            },
            {
                field: "message",
                headerName: translations?.adminLogsPageMessage || "Poruka",
                minWidth: 320,
                flex: 2,
                renderCell: (p) => (
                    <Typography
                        variant="body2"
                        sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}
                        title={p.value}
                    >
                        {p.value}
                    </Typography>
                ),
            },
            {
                field: "fail_success",
                headerName: translations?.adminLogsPageSuccess || "Status",
                minWidth: 140,
                align: "center",
                headerAlign: "center",
                sortable: false,
                filterable: false,
                renderCell: (p) => {
                    const ok = Number(p.value) === 1;
                    return (
                        <StatusBadge
                            status={ok ? "active" : "inactive"}
                            label={
                                ok
                                    ? translations?.adminLogsPageSuccessStatus ||
                                      "Uspešno"
                                    : translations?.adminLogsPageErrorStatus ||
                                      "Greška"
                            }
                        />
                    );
                },
            },
        ],
        [translations]
    );

    return (
        <Box>
            <PageHeader
                icon={<NotificationsOutlinedIcon />}
                eyebrow={
                    translations?.adminAdministratorMenuNotifications ||
                    "Notifications"
                }
                title={translations?.adminLogsPageTitle || "Obaveštenja"}
                description={
                    translations?.adminLogsPageSubtitle ||
                    "Sistemski događaji i greške."
                }
            />

            <SectionCard padded={false}>
                <DataTable
                    rows={data?.data || []}
                    columns={columns}
                    loading={isLoading}
                    rowHeight={56}
                    emptyIcon={<NotificationsOutlinedIcon />}
                    emptyTitle={
                        translations?.noLogsTitle || "Nema obaveštenja"
                    }
                />
            </SectionCard>
        </Box>
    );
};

export default LogsPage;